import { useEffect } from 'react';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import configure from 'configure';

// Live lead-list sync -- NOT a notification/toast. Subscribes to this
// user's private-lead-user-{id} channel (private because it carries lead
// data, unlike the public notifications.${userId} channel used by
// NotificationComponent.js) and re-broadcasts every 'lead-changed' event as
// a window CustomEvent, so any page that cares (currently
// pages/Sales/Lead/index.js) can patch or refetch its own local state
// without needing a shared store.
//
// Backend side: Backend-India/utils/leadRealtime.js decides who receives
// each event (everyone currently permitted to see that lead, per
// tblearth_userpermission), and Backend-India/controller/pusherAuthController.js
// authorizes the channel subscription below.
const LeadRealtimeSync = ({ userId }) => {
    useEffect(() => {
        if (!userId) return;

        window.Pusher = Pusher;
        const echo = new Echo({
            broadcaster: 'pusher',
            key: 'adcc6be71edac68899eb',
            cluster: 'ap2',
            forceTLS: true,
            authEndpoint: `${configure.nodeApi}/pusher/auth`,
            auth: {
                params: { user_id: userId },
            },
        });

        const channelName = `lead-user-${userId}`;
        const channel = echo.private(channelName);

        channel.listen('.lead-changed', (event) => {
            window.dispatchEvent(new CustomEvent('lead-changed', { detail: event }));
        });

        return () => {
            echo.leave(channelName);
        };
    }, [userId]);

    return null;
};

export default LeadRealtimeSync;
